import { toggleBodyFixed, toggleClass } from "@src/utils/dom";
import "./header.css";

export default function setupHeader() {
  const button = document.querySelector("#container-header-button");
  const container = button?.closest(".container-header");

  if (!container || !button) return;

  button.addEventListener("click", () => {
    toggleClass(container, "container-header__active");
    toggleBodyFixed();
  });
}
